import { Button } from "@shared/ui/button";
import { Card } from "@shared/ui/card";
import { ClipboardList, Edit, MessageSquare, UserX, Zap } from "lucide-react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetFieldForceDetails,
  useUpdateFieldForceActiveStatus,
} from "../../hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { CommunicationDialog } from "@features/cx/shared/components/CommunicationDialog";
import {
  useChannelTemplates,
  useChannelType,
  useSendCommunication,
} from "@features/cx/consumerManagement/hooks";
import { DisableAccountConfirmation } from "./DisableAccountConfirmation";

export const QuickActions = () => {
  const navigate = useNavigate();
  const { id, ff_no } = useParams();
  const [openSendComm, setOpenSendComm] = useState(false);
  const [openDisableDialog, setOpenDisableDialog] = useState(false);
  const { data: technician } = useGetFieldForceDetails(ff_no || "");
  console.log(technician);
  const { mutate: updateAccountStatus, isPending: isUpdatingAccess } = useUpdateFieldForceActiveStatus(
    id,
    ff_no,
  );
  const remoteUtilityId = useRemoteUtilityId();

  const isUserAccess = technician?.isUserAccess;
  const actionType = isUserAccess ? "disable" : "enable";

  const handleToggleAccountStatus = () => {
    updateAccountStatus({
      app_account_access: !isUserAccess,
    }, {
      onSuccess: () => setOpenDisableDialog(false),
    });
  };

  return (
    <Card className="p-4 h-full">
      <div className="flex items-center gap-2 mb-4">
        <Zap className="h-5 w-5" />
        <h3 className="font-semibold text-lg">Quick Actions</h3>
      </div>

      <div className="space-y-4">
        <Button
          className="w-full justify-start gap-2 bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 h-10 shadow-sm"
          variant="ghost"
          onClick={() => setOpenSendComm(true)}
        >
          <MessageSquare className="h-5 w-5" />
          <span className="font-medium">Send Communication</span>
        </Button>

        <Button
          className="w-full justify-start gap-2 h-10 text-gray-700 border border-gray-200 bg-white hover:bg-gray-50 shadow-sm"
          variant="ghost"
          onClick={() =>
            navigate(`/service-orders/field-force/edit/${id}/${ff_no}`)
          }
        >
          <Edit className="h-5 w-5" />
          <span className="font-medium">Edit Profile</span>
        </Button>

        <Button
          className="w-full justify-start gap-2 h-10 text-gray-700 border border-gray-200 bg-white hover:bg-gray-50 shadow-sm"
          variant="ghost"
          onClick={() => navigate(`/service-orders/dispatcher`)}
        >
          <ClipboardList className="h-5 w-5" />
          <span className="font-medium">Assign Service Order</span>
        </Button>

        <div className="pt-4 border-t border-gray-100">
          <Button
            onClick={() => setOpenDisableDialog(true)}
            className={`w-full justify-start gap-3 h-10 ${
              isUserAccess
                ? "text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700 hover:border-red-300"
                : "text-green-600 border-green-200 hover:bg-green-50 hover:text-green-700 hover:border-green-300"
            }`}
            variant="outline"
          >
            {isUserAccess ? (
              <UserX className="h-5 w-5" />
            ) : (
              <Zap className="h-5 w-5" />
            )}

            <span className="font-medium">
              {isUserAccess ? "Disable App Account" : "Enable App Account"}
            </span>
          </Button>
        </div>
      </div>
      <CommunicationDialog
        isOpen={openSendComm}
        onClose={() => setOpenSendComm(false)}
        consumerId={id || undefined}
        remoteUtilityId={Number(remoteUtilityId)}
        email={technician?.email}
        phone={technician?.contactNumber}
        useChannelType={useChannelType}
        useChannelTemplates={useChannelTemplates}
        useSendCommunication={useSendCommunication}
        communicationType="meterReader"
      />

      <DisableAccountConfirmation
        isOpen={openDisableDialog}
        onClose={() => setOpenDisableDialog(false)}
        onConfirm={handleToggleAccountStatus}
        name={technician?.name}
        isLoading={isUpdatingAccess}
        actionType={actionType}
      />
    </Card>
  );
};
